module.exports = __webpack_public_path__ + "static/img/profile-target-5.32b37739.png";